import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import {Button, Form, Spinner} from "react-bootstrap";
import {useSelector} from "react-redux";


const AddMonthlyInspection = () => {

    let navigate = useNavigate();

    const [client, setClient] = useState()
    const [address, setAddress] = useState()
    const [inspection_date, set_inspection_date] = useState('')
    const [inspection_type, set_inspection_type] = useState('DEFAULT')
    const [system_1_readings, set_system_1_readings] = useState('')
    const [system_2_readings, set_system_2_readings] = useState('')
    const [inspected_by, set_inspected_by] = useState('')
    const [comments, set_comments] = useState('N/A')
    const [floor_plan, set_floor_plan] = useState(null);

    const [doneSubmitting, setDoneSubmitting] = useState(false)

    const {id} = useParams();
    const userLogin = useSelector(state => state.userLogin)
    const {userInfo} = userLogin

    const loadClient = async () => {
        const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/clients/${id}/`, {
        // const {data} = await axios.get(`http://127.0.0.1:8000/api/clients/${id}/`, {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        })
        // console.log(data.id)
        setClient(data.id)
        setAddress(data.work_site_address)
    }

    let redirect = ''
    if (userInfo){
        if (userInfo.group === "AdminSuper"){
            redirect = '/inspections_dash/'
        } else if (userInfo.group === "Finance") {
            redirect = '/finance_active_work_orders'
        } else if (userInfo.group === "Logistics") {
            redirect = '/logistics_active-work_orders'
        } else if (userInfo.group === "Tech") {
            redirect = '/tech_work_orders'
        }
    }

    useEffect(() => {
        loadClient()
    }, []);

    const CreateMonthlyInspection = async () => {
        setDoneSubmitting(true)
        let formField = new FormData()
        formField.append('client', client)
        formField.append('inspection_date', inspection_date)
        formField.append('inspection_type', inspection_type)
        formField.append('system_1_readings', system_1_readings)
        formField.append('system_2_readings', system_2_readings)
        formField.append('inspected_by', inspected_by)
        formField.append('comments', comments)
        if (floor_plan !== null){
            formField.append('floor_plan', floor_plan)
        }

        await axios({
            method: 'post',
            url: `https://homesafetysolutions.pythonanywhere.com/api/clients/${client}/add_monthly_inspection/`,
            // url: `http://127.0.0.1:8000/api/clients/${client}/add_monthly_inspection/`,
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            },
            data: formField,
        }).then(() => {
            navigate(redirect)
        })
        setDoneSubmitting(false)
    }

    return (
        <div>
            <h1>Create Monthly Inspection for: {address}</h1>

            <Form>
                <Form.Group controlId={'inspection_date'}>
                    <Form.Label>Inspection Date:</Form.Label>
                    <Form.Control
                        type={'date'}
                        value={inspection_date}
                        onChange={(e) => set_inspection_date(e.target.value)}
                    />
                </Form.Group>

                <Form.Group controlId={'inspection_type'}>
                    <Form.Label>Inspection Type?</Form.Label>
                    <Form.Select
                        // value={service_order}
                        onChange={(e) => set_inspection_type(e.target.value)}
                        defaultValue={'DEFAULT'}
                    >
                        <option value="DEFAULT" disabled>Monthly Or Quarterly</option>
                        <option value="Monthly">Monthly</option>
                        <option value="Quarterly">Quarterly</option>
                    </Form.Select>
                </Form.Group>

                <Form.Group controlId={'system_1_readings'}>
                    <Form.Label>System 1 readings:</Form.Label>
                    <Form.Control
                        type={'text'}
                        placeholder={"System 1 Readings"}
                        value={system_1_readings}
                        onChange={(e) => set_system_1_readings(e.target.value)}
                    />
                </Form.Group>

                <Form.Group controlId={'system_2_readings'}>
                    <Form.Label>System 2 Readings:</Form.Label>
                    <Form.Control
                        type={'text'}
                        placeholder={"System 2 Readings"}
                        value={system_2_readings}
                        onChange={(e) => set_system_2_readings(e.target.value)}
                    />
                </Form.Group>

                <Form.Group controlId={'inspected_by'}>
                    <Form.Label>Inspected By:</Form.Label>
                    <Form.Control
                        type={'text'}
                        placeholder={"Inspected By"}
                        value={inspected_by}
                        onChange={(e) => set_inspected_by(e.target.value)}
                    />
                </Form.Group>

                <Form.Group controlId={'comments'}>
                    <Form.Label>Comments:</Form.Label>
                    <Form.Control
                        type={'text'}
                        placeholder={"Comments"}
                        value={comments}
                        onChange={(e) => set_comments(e.target.value)}
                    />
                </Form.Group>

                <Form.Group controlId={'floor_plan'}>
                    <Form.Label>Floor Plan:</Form.Label>
                    <Form.Control
                        type={'file'}
                        onChange={(e) => set_floor_plan(e.target.files[0])}
                    />
                </Form.Group>

                <br/>
                {
                    doneSubmitting
                        ?
                        (
                            <span>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                Loading...
                            </span>
                        )
                        :
                        (
                            <Button className={'btn btn-success'} onClick={CreateMonthlyInspection}>Create Monthly Inspection</Button>
                        )
                }
            </Form>

        </div>
    );

};

export default AddMonthlyInspection